// import * as React from 'react';
import { Route, Routes } from "react-router";
import {
  Header,
  Footer,
  Directory,
  Search,
  FileList,
  SiteMap,
  NotFound,
  UseGaTracker,
  Layout
} from "./components";
import { useSearch } from "./hooks/useSearch";
import BlobCountContext from "./context/BlobCountContext";
import SearchContext from "./context/SearchContext";

import { useEffect, useState } from "react";
import Config from "./config.json";
import { BlobServiceClient } from "@azure/storage-blob";
  
const BLOB_COUNT_LOGS = false;

export default function App() {
  if (process.env.NODE_ENV === "production") {
    UseGaTracker();
  }

  // Call the hook to get filter state and methods
  const searchContextValue = useSearch();

  //#region Blob Count
  const [blobCounts, setBlobCounts] = useState({});
  const [folderMetadata, setFolderMetadata] = useState({});
  
  useEffect(() => {
    if (BLOB_COUNT_LOGS) console.log("App => useEffect => getBlobCounts");
    getBlobCounts();
  }, []);
  
  async function getBlobCounts() {
    const blobServiceClient = new BlobServiceClient(
      process.env.REACT_APP_STORAGE_ACCOUNT_URL +
      process.env.REACT_APP_STORAGE_SAS
    );
    const containerClient = blobServiceClient.getContainerClient(
      Config.storage.containerName
    );

    if (BLOB_COUNT_LOGS) console.log(containerClient)
    
    const countPromises = Config.storage.folders
      .filter(folder => !folder.hidden)
      .map(async (folder) => {
        if (BLOB_COUNT_LOGS) console.log("Counting blobs in folder:", folder.name);
        let count = 0;
        let listOptions = {
          prefix: folder.name + "/",
          includeMetadata: true
        };
        let folderDropdownOptions = {};
        for await (const blob of containerClient.listBlobsFlat(listOptions)) {
          for (const field of folder.dropdownFields || []) {
            if (!folderDropdownOptions[field]) folderDropdownOptions[field] = new Set();
            const metadataValue = blob.metadata ? blob.metadata[field] : null;
            if (metadataValue) {
              folderDropdownOptions[field].add(metadataValue);
            }
          }
          count++;
        }
        setFolderMetadata(prev => ({ ...prev, [folder.name]: folderDropdownOptions }));
        setBlobCounts(prev => ({ ...prev, [folder.name]: count }));
        return { name: folder.name, count };
      });

    await Promise.all(countPromises);
  }
  //#endregion

  return (
    <div className="App">
      <Header />
      <BlobCountContext.Provider value={blobCounts}>
        <SearchContext.Provider value={searchContextValue}>
          <Routes>
            <Route path="/" element={<Directory />} />
            <Route exact path="/search" element={<Search />} />
            {Config.storage.folders.map((folder, i) => (
            <Route element={<Layout folderMetadata={folderMetadata} title={folder.title} description={folder.description} />}>
              <Route 
                key={folder.routePath} 
                exact path={folder.routePath} 
                element={
                <FileList 
                  folder={folder.name} 
                  title={folder.title} />
              } />
            </Route>
            ))}

              <Route exact path="/sitemap" element={<SiteMap />} />
              <Route element={<NotFound />} />
            
          </Routes>
        </SearchContext.Provider>
      </BlobCountContext.Provider>
      <Footer />
    </div>
  );
}
